export default [
    {
        heading: 'Investičný dotazník',
        conditions: [0.95, 1],
        questions: [
            {
                id: 1,
                text: 'Vzdelanie:',
                value: {},
                options: [
                    {
                        value: {points: 2, text: 'Vysokoškolské'}
                    },
                    {
                        value: {points: 0, text: 'Stredoškolské'},
                    },
                    {
                        value: {points: -2, text: 'Základné'},
                    }
                ]
            },
            {
                id: 2,
                text: 'Je Vaše najvyšie dosiahnuté vzdelanie ekonomického zamerania?',
                value: {},
                input1: null,
                    input2: null,
                    options: [
                    {
                        value: {points: 3, text: "áno"}
                    },
                    {
                        value: {points: 0, text: "nie"}
                    }
                ]
            },
            {
                id: 3,
                text: 'Váš hlavný zdroj príjmu:',
                input: {
                    label: 'Oblasť',
                    type: 'text',
                    required: true,
                    hidden: true,
                    placeholder: "napr. lekár",
                    value: ''
                },
                value: [],
                options: [
                    {
                        value: {points: 1, text: "Zamestnanec", showInput: true}
                    },
                    {
                        value: {points: 1, text: "SZČO", showInput: true}
                    },
                    {
                        value: {points: 1, text: "Podnikateľ", showInput: true}
                    },
                    {
                        value: {points: -1, text: "Študent"}
                    },
                    {
                        value: {points: -1, text: "Dôchodca"}
                    },
                    {
                        value: {points: -3, text: "Nezamestnaný"}
                    }
                ]
            },
            {
                id: 4,
                text: 'Ste Vy alebo Vám blízka osoba politicky exponovanou osobou?',
                value: {},
                options: [
                    {
                        value: {points: 0, text: "áno"}
                    },
                    {
                        value: {points: 0, text: "nie"}
                    }
                ]
            },
            {
                id: 5,
                text: 'Ako často sledujete dianie na finančných trhoch?',
                value: {},
                options: [
                    {
                        value: {points: 5, text: "denne"}
                    },
                    {
                        value: {points: 3, text: "viac ako raz týždenne"}
                    },
                    {
                        value: {points: 1, text: "menej ako raz týždenne"}
                    },
                    {
                        value: {points: -3, text: "príležitostne"}
                    }
                ],
            },
        ]

    },
    {
        heading: 'Údaje o účte',
        conditions: [2, 4],
        questions: [
            {
                id: 6,
                text: 'Váš investičný zámer',
                multiple: true,
                value: [],
                options: [
                    {
                        value: {points: 0, text: "Zhodnotenie majetku"}
                    },
                    {
                        value: {points: 0, text: "Ochrana kapitálu"}
                    },
                    {
                        value: {points: 1, text: "Príjem z investovania"}
                    },
                    {
                        value: {points: 3, text: "Špekulácia (využitie krátkodobej investičnej príležitosti)"}
                    }
                ]
            },
            {
                id: 7,
                text: 'Obdobie na ktoré chcem investovať:',
                value: {},
                options: [
                    {
                        value: {points: -3, text: "Kratšie ako rok"}
                    },
                    {
                        value: {points: 2, text: "1 až 3 roky"}
                    },
                    {
                        value: {points: 3, text: "3 až 5 rokov"}
                    },
                    {
                        value: {points: 5, text: "viac ako 5 rokov"}
                    }
                ]
            },
            {
                id: 8,
                text: 'Aká je miera rizika, ktorú ste pri investovaní ochotný akceptovať?',
                value: {},
                input: null,
                options: [
                    {
                        value: {points: -3, text: "nízka"}
                    },
                    {
                        value: {points: 0, text: "stredná"}
                    },
                    {
                        value: {points: 1, text: "vysoká"}
                    }
                ]
            },
            {
                id: 9,
                text: 'Aký výnos očakávate od Vašej investície?',
                value: {},
                options: [
                    {
                        value: {points: 0, text: "nízky"}
                    },
                    {
                        value: {points: 1, text: "stredný"}
                    },
                    {
                        value: {points: 3, text: "vysoký"}
                    }
                ]
            },
            {
                id: 10,
                text: 'Ak by hodnota Vašej dlhodobej investície klesla o 20%?',
                values: {},
                options: [
                    {
                        value: {points: -2, text: "svoju investíciu rýchlo predám aby som zabránil vyššej strate"}
                    },
                    {
                        value: {points: 0, text: "počkám na ďalší vývoj a ak nedôjde ku zmene investíciu predám"}
                    },
                    {
                        value: {points: 3, text: "ostanem pokojný a budem sledovať ďalší vývoj"}
                    },
                    {
                        value: {points: 3, text: "zvýšim investíciu aby som využil aktuálny pokles"}
                    }
                ]
            },
            {
                id: 11,
                text: 'Strata plánovanej investície by:',
                value: {},
                options: [
                    {
                        value: {points: 0, text: "Nemala vplyv na môj životný štandard"}
                    },
                    {
                        value: {points: -1, text: "Znížila životný štandard"}
                    },
                    {
                        value: {points: -3, text: "Znamenala existečné problémy"}
                    }
                ]
            }
        ]
    },
    {
        heading: 'Príjem a hodnota majetku',
        conditions: [-2, 0],
        questions: [
            {
                id: 12,
                text: 'Aká je celková hodnota Vášho majetku (nehnuteľnosti, hmotný majetok, finančné prostriedky atď.)?',
                value: {},
                options: [
                    {
                        value: {points: 3, text: "Viac ako 500 000 EUR"}
                    },
                    {
                        value: {points: 2, text: "Od 100 000 EUR do 500 000 EUR"}
                    },
                    {
                        value: {points: 0, text: "Menej ako 100 000 EUR"}
                    }
                ]
            },
            {
                id: 13,
                text: 'Investované peniaze sú:',
                value: {},
                options: [
                    {
                        value: {points: 0, text: "Môj vlastný kapitál"}
                    },
                    {
                        value: {points: -8, text: "Peniaze získané z pôžičky alebo úveru"}
                    },
                    {
                        value: {points: -8, text: "Peniaze od inej osoby, ktorá mi ich za týmto účelo požičala"}
                    }
                ]
            },
            {
                id: 14,
                text: 'Aká je výška Vášho hrubého ročného príjmu:',
                value: {},
                options: [
                    {
                        value: {points: 5, text: "Viac ako 50 000 EUR"}
                    },
                    {
                        value: {points: 2, text: "Viac ako 30 000 EUR"}
                    },
                    {
                        value: {points: 1, text: "Viac ako 15 000 EUR"}
                    },
                    {
                        value: {points: 0, text: "Menej"}
                    }
                ],
            }
        ]
    },
    {
        heading: 'Investičné znalosti a skúsenosti',
        conditions: [1, 2],
        questions: [
            {
                id: 15,
                text: 'Vaše skúsenosti s investovaním, finančným trhom a obchodovaním na finančnom trhu pokladám za:',
                value: {},
                options: [
                    {
                        value: {points: 0, text: "príležitostné obchodovanie s malým objemom finančných prostriedkov"}
                    },
                    {
                        value: {points: 1, text: "príležitostné obchodovanie s väčším objemom finančných prostriedkov"}
                    },
                    {
                        value: {points: 1, text: "pravidelné obchodovanie s malým objemom finančných prostriedkov"}
                    },
                    {
                        value: {points: 3, text: "pravidelné obchodovanie s väčším objemom finančných prostriedkov"}
                    }
                ]
            },
            {
                id: 16,
                multiple: true,
                text: 'Aké druhy cenných papierov poznáte a rozumiete ich hlavným charakteristikám:',
                value: [],
                options: [
                    {
                        value: {points: 1, text: "fondy (cenné papiere kolektívneho investovania)"}
                    },
                    {
                        value: {points: 2, text: "akcie"}
                    },
                    {
                        value: {points: 1, text: "dlhopisy a zmenky"}
                    },
                    {
                        value: {points: 3, text: "investičné certifikáty a ETF"}
                    },
                    {
                        value: {points: 5, text: "opcie, futures, swapy a forwardy"}
                    },
                    {
                        value: {points: -2, text: "nepoznám"}
                    },
                ]
            },
            {
                id: 17,
                multiple: true,
                text: 'V posledných piatich rokoch som investoval do:',
                value: [],
                options: [
                    {
                        value: {points: 1, text: "fondy (cenné papiere kolektívneho investovania)"}
                    },
                    {
                        value: {points: 3, text: "akcie, investičné certifikáty, ETF"}
                    },
                    {
                        value: {points: 1, text: "dlhopisy a zmenky"}
                    },
                    {
                        value: {points: 5, text: "opcie, futures, swapy a forwardy"}
                    },
                ]
            }
        ]
    },
    {
        heading: 'Overovacie otázky',
        conditions: [1, 2],
        questions: [
            {
                id: 18,
                text: 'Emitent cenného papiera je:',
                value: {},
                options: [
                    {
                        value: {points: -0.5, text: "označenie banky"}
                    },
                    {
                        value: {points: -0.5, text: "označenie veriteľa"}
                    },
                    {
                        value: {points: 3, text: "ten, kto vydal cenný papier"}
                    }
                ]
            },
            {
                id: 19,
                text: 'Diverzifikácia je:',
                value: {},
                options: [
                    {
                        value: {points: -0.5, text: "spôsob reinvestovania"}
                    },
                    {
                        value: {points: 2, text: "rozloženie investície za účelom zníženia rizika"}
                    },
                    {
                        value: {points: -0.5, text: "spôsob rozdelenia zisku"}
                    }
                ]
            },
            {
                id: 20,
                text: 'Akcia je kapitálový cenný papier, s ktorým:',
                value: {},
                options: [
                    {
                        value: {points: -0.5, text: "si môže požičať peniaze"}
                    },
                    {
                        value: {points: -0.5, text: "sa nemôže obchodovať "}
                    },
                    {
                        value: {points: 2, text: "sú spojené práva akcionára podieľať sa na riadení spoločnosti, na zisku a na likvidačnom zostatku"}
                    }
                ]
            },
            {
                id: 21,
                text: 'Za dôležité kritérium pri kúpe dlhopisu môžeme považovať aj:',
                value: {},
                options: [
                    {
                        value: {points: -1, text: "bonitu držiteľa dlhopisu"}
                    },
                    {
                        value: {points: -1, text: "koľko peňazí chcem do dlhopisu investovať"}
                    },
                    {
                        value: {points: 1, text: "bonitu emitenta dlhopisu"}
                    }
                ]
            }
        ]
    }
]
